import { AlertTriangle } from "lucide-react";

export default function ConfirmDeleteModal({
  open,
  title,
  description,
  confirmLabel = "Delete",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onCancel}
      />

      {/* Modal */}
      <div
        className="
          relative
          w-full max-w-sm
          rounded-xl
          bg-white
          shadow-xl
          border border-[var(--color-border)]
          p-6
        "
      >
        <div className="flex items-start gap-3">
          <div className="mt-1 text-red-600">
            <AlertTriangle size={22} />
          </div>

          <div className="space-y-1">
            <h3 className="text-base font-semibold">{title}</h3>
            <p className="text-sm text-[var(--color-text-muted)]">
              {description}
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="
              px-4 py-2
              text-sm
              rounded-md
              border border-[var(--color-border)]
              hover:bg-[var(--color-bg-muted)]
            "
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="
              px-4 py-2
              text-sm
              rounded-md
              bg-red-600
              text-white
              hover:bg-red-700
            "
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
